import { getApiClientsContext } from "waapi/front-utils/hooks/useApiClients/context.js";
import { useContext } from "react";
import { ApiClient, ApiStaffClient } from "./types.js";

export const ApiClientsContext = getApiClientsContext<ApiClient, ApiStaffClient>();

export const useApiClients = () => useContext(ApiClientsContext);
